<script lang="ts">
    import { BOOKING_STATUS } from "../../model/Booking";
    import { capitalizeFirstLetter } from "../../utility/helper";

    interface Props {
        status: BOOKING_STATUS;
    }

    let { status }: Props = $props();


    function deriveColorKeyword(status: BOOKING_STATUS): string {
        let colorMap: Map<BOOKING_STATUS,string> = new Map([
            [BOOKING_STATUS.draft, "secondary"],
            [BOOKING_STATUS.canceled, "secondary"],
            [BOOKING_STATUS.requested, "info"],
            [BOOKING_STATUS.aborted, "danger"],
            [BOOKING_STATUS.finished, "success"],
            [BOOKING_STATUS.live, "success"],
            [BOOKING_STATUS.paused, "secondary"],
            [BOOKING_STATUS.planned, "info"],
            [BOOKING_STATUS.rejected, "danger"],
        ]);

        return colorMap.get(status) || "secondary";
    }
</script>

<span class="badge text-bg-{deriveColorKeyword(status)}">{capitalizeFirstLetter(status)}</span>